import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useProjectDocumentTypeList() {
  // Use toast
  const toast = useToast();

  const refProjectDocumentTypeListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    /* { key: "id", label: "編號", sortable: true }, */
    { key: "sort_order", label: "排序", sortable: true },
    { key: "name", stickyColumn: true, label: "狀態", sortable: true },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("sort_order");
  const isSortDirDesc = ref(false);

  const projectDocumentTypeList = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refProjectDocumentTypeListTable.value
      ? refProjectDocumentTypeListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refProjectDocumentTypeListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery ],
    () => {
      refetchData();
    }
  );

  const fetchProjectDocumentTypes = (ctx, callback) => {
    store
      .dispatch("project/fetchProjectDocumentTypes", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { project_document_types, total } = response.data;
        callback(project_document_types);
        totalRow.value = total;
        projectDocumentTypeList.value = project_document_types

      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };



  onMounted(() => {
  });

  return {
    fetchProjectDocumentTypes,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    projectDocumentTypeList,
    refProjectDocumentTypeListTable,
    ability,
    refetchData,
   
  };
}
